import React, { FC } from "react";
import Modal from "../../components/modal/Modal";
import NewsForm from "./NewsForm";
import searchIcon from "../../assets/icons/search.svg";
import addIcon from "../../assets/icons/add-circle.svg";
import { useModal } from "../../customHooks/useModal";
import { showErrorToast } from "../../components/toasts";

interface IHeader {
  searchItems: (value: string) => void;
  page?: number;
  actionData?: any;
}

const Header: FC<IHeader> = ({ searchItems, page, actionData }) => {
  const { showModal, openModal, setModalShow, closeModal } = useModal();

  return (
    <div className="news-header">
      <div className="title">Editing news</div>
      <div className="controls">
        <label htmlFor="search">
          <span className="input-container">
            <span className="icon">
              <img src={searchIcon} alt="search" />
            </span>
            <input
              type="text"
              id="search"
              className="input"
              onChange={(e) => searchItems(e.target.value)}
              placeholder="Search for news"
            />
          </span>
        </label>
        {actionData?.add ? (
          <button
            className="add-button"
            onClick={() => openModal()}
          >
            <img src={addIcon} alt="add article" />
          </button>
        ) : (
          ""
        )}
      </div>
      <Modal show={showModal} onClose={setModalShow} title="Add news">
        <NewsForm page={page} onClose={closeModal} />
      </Modal>
    </div>
  );
};

export default Header;
